const ACCESS_TOKEN_STORAGE_KEY = "flowermaster.access_token";

let memoryAccessToken: string | null = null;

/** 读取当前 HTTP 访问令牌。 */
export function readHttpAccessToken(): string | null {
  if (typeof window === "undefined") {
    return memoryAccessToken;
  }

  try {
    return window.localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY) ?? memoryAccessToken;
  } catch {
    return memoryAccessToken;
  }
}

/** 写入当前 HTTP 访问令牌。 */
export function writeHttpAccessToken(token: string): void {
  const normalizedToken = token.trim();
  memoryAccessToken = normalizedToken || null;

  if (typeof window === "undefined") {
    return;
  }

  try {
    if (normalizedToken) {
      window.localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, normalizedToken);
      return;
    }
    window.localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
  } catch {
    // localStorage 可能被浏览器策略禁用，内存态仍可覆盖当前会话。
  }
}

/** 清除当前 HTTP 访问令牌。 */
export function clearHttpAccessToken(): void {
  memoryAccessToken = null;

  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
  } catch {
    // 忽略浏览器存储不可用场景。
  }
}
